<template>
  <div
      class="modal_body register-table"
      style="height: 430px;"
  >
    <div class="mb20 mt10">
      {{ this.$t('patients.add.description') }}
    </div>
    <KvTable :items="items"/>
    <div class="pop_add_btn">
      <a
          class="btn blue btn_basics pointer no-drag"
          :class="this.isDisabled === false || validateItems().isSuccess === false ? 'disabled' : ''"
          @click="validationCheck"
      >
        {{ $t('patients.add.name') }}
      </a>
    </div>
  </div>
</template>
<script>
import KvTable from '@/components/Table/kvTable'
import {
  _DATE_FORMAT
} from "@/components/Table/static";
import validationMethods from '@/common/lib/validation'
import _API from "@/api";

export default {
  components: {
    KvTable,
  },
  props: [
      'codeRegister'
  ],
  data() {
    const item = this.codeRegister ? [
      {
        index: 0,
        keyTitle: this.$t('user.certNumber'),
        keyType: 'DefaultInput',
        class: [],
        keyRange: [],
        values: undefined,
        maxLength: 9,
        error: false,
        description: this.$t('alert.retry_again'),
        tooltip: {
          msg: this.$t('user.certNumberToolTip'),
        },
        disabled: false,
      },
      {
        index: 1,
        keyTitle: this.$t('user.name'),
        keyType: 'DefaultInput',
        class: [],
        keyRange: [],
        values: undefined,
        maxLength: 20,
      },
      {
        index: 2,
        keyTitle: this.$t('patient.info.gender.key'),
        keyType: 'GenderRadioBox',
        class: ['gender_select'],
        keyRange: [],
        values: undefined
      },
      {
        index: 3,
        keyTitle: this.$t('user.email'),
        keyType: 'EmailInput',
        keyRange: [],
        overlap: true, // 이메일 중복 검사 여부, true면 검사, false면 no 검사
        values: undefined,
        disabled: true,
      },
      {
        index: 4,
        keyTitle: this.$t('patient.info.date_of_birth'),
        keyType: 'SingleDateInput',
        class: [],
        keyRange: [],
        componentOptions: {
          minDate: this.moment().add(-100, 'year').format(),
          maxDate: this.moment().add(-14, 'year').format(),
          popoverVisibility: 'focus',
          popoverDirection: 'top'
        },
        values: undefined,
      }
    ] : [
      {
        index: 0,
        keyTitle: this.$t('user.name'),
        keyType: 'DefaultInput',
        class: [],
        keyRange: [],
        values: undefined,
        maxLength: 20,
      },
      {
        index: 1,
        keyTitle: this.$t('patient.info.gender.key'),
        keyType: 'GenderRadioBox',
        class: ['gender_select'],
        keyRange: [],
        values: undefined
      },
      {
        index: 2,
        keyTitle: this.$t('user.email'),
        keyType: 'EmailInput',
        keyRange: [],
        overlap: true, // 이메일 중복 검사 여부, true면 검사, false면 no 검사
        values: undefined,
      },
      {
        index: 3,
        keyTitle: this.$t('patient.info.date_of_birth'),
        keyType: 'SingleDateInput',
        class: [],
        keyRange: [],
        componentOptions: {
          minDate: this.moment().add(-100, 'year').format(),
          maxDate: this.moment().add(-14, 'year').format(),
          popoverVisibility: 'focus',
          popoverDirection: 'top'
        },
        values: undefined,
      }
    ];

    return {
      items: item,
      code: '',
      errorLog: '',
      isDisabled: !this.codeRegister,
      itemAddList: this.codeRegister ? {
        code: 0,
        name: 1,
        gender: 2,
        email: 3,
        birth: 4,
      } : {
        code: -1,
        name: 0,
        gender: 1,
        email: 2,
        birth: 3,
      },
    }
  },
  methods: {
    ...validationMethods,
    appendPatient() {
      const insertUserInfo = {
        userEmail: '',
        patientInfo: {
          patientInfoName: '',
          patientInfoGender: '',
          patientInfoBirth: '',
        }
      };
      insertUserInfo.userEmail = this.items[this.itemAddList.email].values;
      insertUserInfo.patientInfo.patientInfoBirth = this.moment(this.items[this.itemAddList.birth].values).format(_DATE_FORMAT);
      insertUserInfo.patientInfo.patientInfoName = this.items[this.itemAddList.name].values;
      insertUserInfo.patientInfo.patientInfoGender = this.items[this.itemAddList.gender].values;

      if (this.codeRegister)
        insertUserInfo.patientSyncAuthCode = this.items[this.itemAddList.code].values;

      this.$emit('insertPatient', insertUserInfo)
    },
    validateItems() {
      let resJson = {
        isSuccess: false,
      };

      for (const item of this.items) {
        if (!item.values || item.values === '')
          return resJson;
      }

      const emailValidation = this.checkEmailValidation(this.items[this.itemAddList.email].values);

      if (!emailValidation) {
        this.$modal.show('common-alert-modal', {
          messageType: 'short',
          message: 'account.email_form_mismatch'
        });
        return resJson;
      }

      resJson.isSuccess = true;
      return resJson;
    },
    validationCheck() {
      if (this.isDisabled) {
        const res = this.validateItems();

        if (res.isSuccess === true)
          this.$modal.show('yes-or-no-modal', {questionType: 'save', function: this.appendPatient});
      }
    },
    goBack() {
      this.$emit('changePatientAppendComponent', 0);
    },
    patientOverlap(id) {
      const patientList = this.$store.state.patientList;

      if (patientList.length > 0) {
        for (const patient of patientList) {
          if (patient.patientEmail === id)
            return false;
        }
      }

      return true;
    }
  },
  watch: {
    items: {
      deep: true,
      handler(values) {
        if (this.codeRegister)
          this.code = values[this.itemAddList.code].values;
      }
    },
    code: {
      deep: true,
      handler(newValues, _oldValue) {
        if (newValues?.length === this.items[this.itemAddList.code]?.maxLength) {
          _API.PATIENT.isPatientSyncAuthCodeValid(newValues)
              .then(({data}) => {
                if (data?.isSuccess === true) {
                  this.items[this.itemAddList.name].values = data?.user?.userName;
                  this.items[this.itemAddList.email].values = data?.user?.userEmail;
                  this.isDisabled = data?.user?.userEmail === localStorage.getItem('userEmail') ? false : this.patientOverlap(data?.user?.userEmail);
                } else {
                  this.items[this.itemAddList.code].error = true;
                  this.items[this.itemAddList.code].description = data?.failedCode === 'PAT0202' ? this.$t('alert.codeErrorPat0202') : this.$t('alert.retry_again');
                }
              })
              .catch(() => {
                this.isDisabled = false;
              })
              .finally(() => {
                // This is intentional
              })
        } else {
          this.isDisabled = false;
          this.items[this.itemAddList.code].error = false;
          this.items[this.itemAddList.email].values = undefined;
        }
      }
    },
  },
}
</script>
<style lang="scss">
.sub_title {
  margin-top: 1rem;
}

.gender_select {
  overflow: hidden;

  li {
    width: 47%;
    float: left;
  }
}

.pop_add_btn {
  flex: 1 1 5rem;
  place-items: flex-end;

  .disabled {
    color: var(--grey70);
  }

  .disabled:hover {
    background: var(--grey20);
  }
}

.register-table {
  .table-container {
    grid-template-columns: 1fr;
  }
}
</style>